import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Font,
  ClassicEditor,
  Underline,
  HorizontalLine,
  Image,
  ImageToolbar,
  ImageCaption,
  ImageStyle,
  ImageResize,
  ImageUpload,
  Base64UploadAdapter,
} from 'ckeditor5';

import 'ckeditor5/ckeditor5.css';

interface CkEditorProps {
  id: string;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  toolbar?: string[];
  uploadFeature?: boolean;
}

const CkEditor: React.FC<CkEditorProps> = ({ id, label, value, onChange, uploadFeature }) => {
  const defaultToolbar = [
    'heading',
    '|',
    'fontFamily',
    'fontSize',
    'fontColor',
    'fontBackgroundColor',
    '|',
    'bold',
    'italic',
    'underline',
    '|',
    'bulletedList',
    'numberedList',
    'link',
    'blockQuote',
    'horizontalLine',
    'undo',
    'redo',
    '|',
  ];

  uploadFeature && defaultToolbar.push('insertImage');

  return (
    <div className="rich-text-field">
      {label && <label htmlFor={id}>{label}</label>}

      {
        <CKEditor
          editor={ClassicEditor}
          data={value || ''}
          config={{
            toolbar: defaultToolbar,
            plugins: [
              Essentials,
              Paragraph,
              Bold,
              Italic,
              Font,
              Underline,
              HorizontalLine,
              Image,
              Image,
              ImageToolbar,
              ImageCaption,
              ImageStyle,
              ImageResize,
              ImageUpload,
              Base64UploadAdapter,
            ],
            image: {
              toolbar: [
                'imageStyle:inline',
                'imageStyle:block',
                'imageStyle:side',
                '|',
                'resizeImage',
                // "toggleImageCaption",
                // "imageTextAlternative",
              ],
              resizeOptions: [
                {
                  name: 'resizeImage:original',
                  label: 'Original',
                  value: null,
                },
                {
                  name: 'resizeImage:50',
                  label: '25%',
                  value: '25',
                },
                {
                  name: 'resizeImage:50',
                  label: '50%',
                  value: '50',
                },
                {
                  name: 'resizeImage:75',
                  label: '75%',
                  value: '75',
                },
              ],
              resizeUnit: '%',
            },
          }}
          onChange={(_, editor) => onChange(editor.getData())}
        />
      }
    </div>
  );
};

export default CkEditor;
